<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <template v-if="isEditarForm">
        <div class="table-action-box" v-bind="attrs" v-on="on">
          <v-icon small>mdi-pencil</v-icon>
          <span class="table-action-label">Editar</span>
        </div>
      </template>
      <template v-else>
        <v-btn small color="primary" class="palavra-add-btn" v-bind="attrs" v-on="on">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </template>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">{{ isEditarForm ? 'mdi-pencil' : 'mdi-alphabetical-off' }}</v-icon>
        <div>
          <span class="sc-modal__title">{{ isEditarForm ? 'Editar palavra bloqueada' : 'Bloquear palavra' }}</span>
          <span class="sc-modal__subtitle">A palavra será filtrada das colaborações</span>
        </div>
      </div>

      <!-- Form -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Palavra</label>
          <v-text-field
            solo
            flat
            dense
            background-color="surface_tertiary"
            placeholder="Digite a palavra a ser bloqueada"
            v-model="dsc_palavra"
            hide-details="auto"
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="isEditarForm ? editarPalavraBloqueada() : inserirPalavraBloqueada()"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          {{ isEditarForm ? 'Atualizar' : 'Salvar' }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from '@/services/api';

export default {
  name: "ModalAdicionarOuEditarPalavraBloqueada",
  props: {
    getPalavrasBloqueada: Function,
    editFormData: Object,
    isEditarForm: Boolean,
  },
  data() {
    return {
      loading: false,
      dsc_palavra: "",
      dialog: false,
    };
  },
  watch: {
    dialog(open) {
      if (open) this.seedForm();
    },
  },
  created() {
    this.seedForm();
  },
  methods: {
    seedForm() {
      this.dsc_palavra = this.isEditarForm && this.editFormData
        ? this.editFormData.dsc_palavra
        : "";
    },
    async inserirPalavraBloqueada() {
      try {
        this.loading = true;

        if (this.dsc_palavra.trim() === '') {
          return this.$toast.error('Insira a palavra a ser bloqueada.');
        }

        const payload = {
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          dsc_palavra: this.dsc_palavra,
        };

        const response = await apiClient.post('/inserirPalavraBloqueada', payload);

        if (response.status === 200) {
          await this.getPalavrasBloqueada();
          this.$toast.success('Palavra bloqueada adicionada com sucesso.');
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao bloquear palavra.');
      } finally {
        this.loading = false;
      }
    },
    async editarPalavraBloqueada() {
      try {
        this.loading = true;

        if (this.dsc_palavra.trim() === '') {
          return this.$toast.error('Insira a palavra a ser bloqueada.');
        }

        const payload = {
          cod_palavra_bloqueada: this.editFormData.cod_palavra_bloqueada,
          dsc_palavra: this.dsc_palavra,
        };

        const response = await apiClient.patch('/editarPalavrasBloqueadas', payload);

        if (response.status === 200) {
          this.$toast.success('Palavra bloqueada atualizada com sucesso.');
          await this.getPalavrasBloqueada();
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao editar palavra.');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.dsc_palavra = this.isEditarForm ? this.editFormData.dsc_palavra : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.palavra-add-btn {
  text-transform: none;
  font-weight: var(--sc-weight-semi);
  letter-spacing: 0;
  border-radius: var(--sc-radius-md);
}
</style>
